import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Heart, Calendar, Clock, Battery, Smile, ShieldCheck } from 'lucide-react';
export function Promise() {
  const promises = [{
    icon: <Heart className="w-6 h-6 text-rose" data-id="element-133" />,
    text: 'Comer más liviano sin quedarte con hambre.'
  }, {
    icon: <ShieldCheck className="w-6 h-6 text-sage" data-id="element-134" />,
    text: 'Reducir irritantes típicos (los que más inflaman en la vida real).'
  }, {
    icon: <Calendar className="w-6 h-6 text-terracotta" data-id="element-135" />,
    text: 'Tener un menú flexible que te saque decisiones de encima.'
  }, {
    icon: <Clock className="w-6 h-6 text-rose" data-id="element-136" />,
    text: 'Aprender un protocolo de 24 horas para cuando estás “explotada”.'
  }, {
    icon: <Battery className="w-6 h-6 text-sage" data-id="element-137" />,
    text: 'Bajar el estrés con scripts de 2 minutos (sí, 2).'
  }, {
    icon: <Smile className="w-6 h-6 text-terracotta" data-id="element-138" />,
    text: 'Volver a sentir que vos manejás el plan (y no al revés).'
  }];
  return <section className="py-24 px-4 bg-cream" data-id="element-139">
      <div className="max-w-5xl mx-auto" data-id="element-140">
        <FadeIn className="text-center mb-16" data-id="element-141">
          <h2 className="text-3xl md:text-4xl font-serif text-brown mb-4" data-id="element-142">
            Lo que vas a lograr en 7 días
          </h2>
          <p className="text-sage text-lg font-medium" data-id="element-143">(sin prometer magia)</p>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-144">
          {promises.map((item, index) => <FadeIn key={index} delay={index * 0.1} className="h-full" data-id="element-145">
              <div className="bg-white p-8 rounded-2xl shadow-sm border border-cream-dark h-full hover:shadow-md transition-shadow duration-300 flex flex-col items-center text-center md:items-start md:text-left" data-id="element-146">
                <div className="mb-6 p-3 bg-cream rounded-full inline-block" data-id="element-147">
                  {item.icon}
                </div>
                <p className="text-lg text-brown leading-relaxed font-medium" data-id="element-148">
                  {item.text}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}